import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./ReinviteModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import CheckBoxItem from "../../Shared/CheckBoxItem";

/**
 * Interactive component. Modal used for sending email invites.
 */

export function ReinviteModal({
  isOpen,
  onClose,
  onClick,
  wwgEmail,
  altEmail,
}) {
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const [isAltChecked, setIsAltChecked] = useState(false);

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="REINVITE"
        closeBtn="none"
        className={styles.modal}
      >
        <div className={styles.contentContainer}>
          <p className={styles.contentText}>
            Send an invite email for a user who hasn't received one.
          </p>
          <div className={styles.emailContainer}>
            <p className={styles.select}>SELECT EMAIL:</p>
            <div className={styles.emailDiv}>
              <div className={styles.emailsDiv}>
                <CheckBoxItem
                  name={wwgEmail}
                  value={wwgEmail}
                  checked={isEmailChecked}
                  onClick={() => {
                    setIsEmailChecked(!isEmailChecked);
                  }}
                />

                <span className={styles.wwgText}>WWG Email Address</span>
              </div>
            </div>

            <div className={styles.emailDiv}>
              <div className={styles.emailsDiv}>
                <CheckBoxItem
                  name={altEmail}
                  value={altEmail}
                  checked={isAltChecked}
                  onClick={() => {
                    setIsAltChecked(!isAltChecked);
                  }}
                />

                <span className={styles.wwgText}>
                  Alternative Email Address
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.resendBtn}
                  onClick={onClick}
                >
                  RESEND INVITE
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

ReinviteModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when resend invite is clicked.
   */
  onClick: PropTypes.func,
  /**
   * 	String to display the WWG email
   */
  wwgEmail: PropTypes.string,
  /**
   * 	String to display the WWG email
   */
  altEmail: PropTypes.string,
};
